import { createRouter, createWebHashHistory } from 'vue-router';

import Home from '@/pages/Home.vue';

import Stations from '@/pages/Stations.vue';
import Station from '@/pages/Station.vue';
import Measures from '@/pages/Measures.vue';
import MeasuresMap from '@/pages/MeasuresMap.vue';
import Meteogram from '@/pages/Meteogram.vue';
import Webcams from '@/pages/Webcams.vue';
import Webcam from '@/pages/Webcam.vue';

import RadarHome from '@/pages/RadarHome.vue';
import Radar from '@/pages/Radar.vue';
import RadarP from '@/pages/RadarP.vue';
import RadarHMC from '@/pages/RadarHMC.vue';
import Storm from '@/pages/Storm.vue';
import Wind from '@/pages/Wind.vue';

import Earthquakes from '@/pages/Earthquakes.vue';

import Licence from '@/pages/Licence.vue';
import Credits from '@/pages/Credits.vue';

let R = createRouter({
  mode: 'history',
  history: createWebHashHistory(),
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/stazioni',
			name: 'stazioni',
			component: Stations
		},
		{
			path: '/stazione/:id',
			name: 'stazione',
			component: Station
		},
		{
			path: '/misure/:station_id/:sensor_id',
			name: 'misure',
			component: Measures
		},
		{
			path: '/meteogramma',
			name: 'meteogramma',
			component: Meteogram,
			props: route => ({ lat: Number(route.query.lat), lng: Number(route.query.lng)})
		},
		{
			path: '/mappa_sensori',
			name: 'mappa_sensori',
			component: MeasuresMap
		},
		{
			path: '/webcam',
			name: 'webcam',
			component: Webcams
		},
		{
			path: '/immagini/:id',
			name: 'immagini',
			component: Webcam
		},
		{
			path: '/radar',
			name: 'radar_home',
			component: RadarHome
		},
		{
			path: '/radar/:product',
			name: 'radar',
			component: Radar
		},
		{
			path: '/radar_cumulate',
			name: 'radar_cumulate',
			component: RadarP
		},
		{
			path: '/temporali',
			name: 'temporali',
			component: Storm
		},
		{
			path: '/vento',
			name: 'vento',
			component: Wind
		},
		{
			path: '/radar_hmc',
			name: 'hmc',
			component: RadarHMC
		},
		{
			path: '/terremoti',
			name: 'terremoti',
			component: Earthquakes
		},
		{
			path: '/licenza',
			name: 'licenza',
			component: Licence
		},
		{
			path: '/attribuzioni',
			name: 'attribuzioni',
			component: Credits
		}
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});


export default R;
